import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import ParentService from 'services/ParentService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    parentData: [],
    singleParent:[],
    parentPlayer:[],
}


export const getParent = createAsyncThunk('parent/getParent', async (params, { rejectWithValue }) => {
	
	try {
		const response = await ParentService.getParent(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const getParentWithId = createAsyncThunk('parent/getParentWithId', async (params, { rejectWithValue }) => {
	
	try {
		const response = await ParentService.getParentWithId(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getParentPlayer = createAsyncThunk('parent/getParentPlayer', async (params, { rejectWithValue }) => {
	
	try {
		const response = await ParentService.getParentPlayer(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const parentSlice = createSlice({
    name: 'parent',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getParent.pending, (state) => {
            state.loading = true
        })
        .addCase(getParent.fulfilled, (state, action) => {
            state.loading = false
            state.parentData = action.payload
        })
        .addCase(getParent.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
        .addCase(getParentWithId.pending, (state) => {
            state.loading = true
        })
        .addCase(getParentWithId.fulfilled, (state, action) => {
            state.loading = false
            state.singleParent = action.payload
        })
        .addCase(getParentWithId.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getParentPlayer.pending, (state) => {
            state.loading = true
        })
        .addCase(getParentPlayer.fulfilled, (state, action) => {
            state.loading = false
            state.parentPlayer = action.payload
        })
        .addCase(getParentPlayer.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
    }
});


export default parentSlice.reducer;